import { useEffect } from 'react';

/**
 * Stops the page behind a modal surface from scrolling (or rubber-banding on
 * iOS) while `active`. Restores the value it found rather than clearing it, so
 * a dialog opened over another locked surface leaves that surface locked when
 * it closes.
 */
export function useBodyScrollLock(active: boolean): void {
  useEffect(() => {
    if (!active) return;
    const previous = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = previous;
    };
  }, [active]);
}
